import React from 'react';
import ServerConfig from './ServerConfig';
import LoggingConfig from './LoggingConfig';
import MetadataConfig from './MetadataConfig';
import ResourcesConfig from './ResourcesConfig';

function ConfigForm({ config, setConfig, activeTab }) {
  const updateConfig = (section, data) => {
    setConfig(prev => ({ ...prev, [section]: data }));
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'server':
        return <ServerConfig data={config.server || {}} onChange={(data) => updateConfig('server', data)} />;
      case 'logging':
        return <LoggingConfig data={config.logging || {}} onChange={(data) => updateConfig('logging', data)} />;
      case 'metadata':
        return <MetadataConfig data={config.metadata || {}} onChange={(data) => updateConfig('metadata', data)} />;
      case 'resources':
        return <ResourcesConfig data={config.resources || {}} onChange={(data) => updateConfig('resources', data)} />;
      default:
        return null;
    }
  };

  return (
    <div className="tab-content">
      {renderTabContent()}
    </div>
  );
}

export default ConfigForm;